import Polyglot from 'node-polyglot';

export const LanguageEnum = {
  EN: 'en',
  ZH_CN: 'zh_Hant',
  VI: 'vi',
  ID: 'id',
  TH: 'th',
};

export const languages = Object.keys(LanguageEnum).map(
  (key) => LanguageEnum[key]
);

export const DomainLanguageMap = {
  sg: 'en',
  io: 'en',
  vn: 'vi',
  th: 'th',
  id: 'id',
  tw: 'zh_Hant',
};

const translations = languages.reduce(
  (result, lang) => ({
    ...result,
    [lang]: new Polyglot({
      locale: lang,
      // eslint-disable-next-line import/no-dynamic-require,global-require
      phrases: require(`./transify/${lang}/translation.json`),
      interpolation: { prefix: '{{', suffix: '}}' },
    }),
  }),
  {}
);

export function getServerLanguage(ctx) {
  const { req } = ctx || {};
  const { headers, url } = req || {};
  const { host } = headers || {};

  if (process.env.HAISERVE_DOMAINS.includes(host)) {
    // Get languageParam from url
    // Example: help.haiserve.com/vn/search -> we will take vn at key language
    const languageParam = url ? url.substr(1, 2) : undefined;
    return DomainLanguageMap[languageParam] || 'en';
  }

  const tld = host ? host.split(':')[0].split('.').pop() : undefined;
  return DomainLanguageMap[tld] || 'en';
}

export function getClientLanguage() {
  const { host, pathname } = window.location;

  if (process.env.HAISERVE_DOMAINS.includes(host)) {
    // Get languageParam from url
    // Example: help.haiserve.com/vn/search -> we will take vn at key language
    const languageParam = pathname ? pathname.substr(1, 2) : undefined;
    return DomainLanguageMap[languageParam] || 'en';
  }

  const tld = host ? host.split(':')[0].split('.').pop() : undefined;

  return DomainLanguageMap[tld] || 'en';
}

/**
 * Translates given key with specified options. Specify default value and/or language in options to fallback on if key does not exist for translation.
 * @param key key of string to be translated
 * @param options translation options
 */
export default function locale(
  key,
  selectedLocale = 'en',
  { _ = `<${key}>`, defaultLang, ...rest } = {}
) {
  const options = { _, ...rest };
  const translation = translations[selectedLocale];

  if (defaultLang) {
    const defaultLangResult = translations[defaultLang].t(key, options);
    return translation.t(key, { _: defaultLangResult, ...rest });
  }

  return translation.t(key, options);
}
